module.exports = __webpack_public_path__ + "img/img_service_04.56f4bda0.png";